import React from 'react';
import PropTypes from 'prop-types';

const CNAME = 'HeroImage';

const HeroImageSources = ({ treatments, title = '' }) => {
  let imgSrc = null;
  const sources = treatments.map(({ href, media, defaultImg, key }) => {
    const srcSet = href;
    imgSrc = imgSrc || (defaultImg && srcSet);
    return <source {...{ srcSet, media, key, type: 'image/jpeg' }}/>;
  });

  sources.push(<img key="img" className={`${CNAME}__img`} src={imgSrc} alt={title} />);
  return sources;
};

HeroImageSources.propTypes = {
  treatments: PropTypes.arrayOf(PropTypes.shape({
    defaultImg: PropTypes.bool.isRequired,
    href: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
    media: PropTypes.string.isRequired
  })).isRequired,
  title: PropTypes.string
};

export default HeroImageSources;
